// managerApp/customerList
export const customerByReloadYardByActiveByAccountNameByName = /* GraphQL */ `
  query CustomerByReloadYardByActiveByAccountNameByName(
    $reloadYardId: ID
    $activeAccountNameLastName: ModelCustomerReloadYardAccountCustomerByReloadYardByActiveByAccountNameByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerReloadYardAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByReloadYardByActiveByAccountNameByName(
      reloadYardId: $reloadYardId
      activeAccountNameLastName: $activeAccountNameLastName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountName
        customerId
        customer {
          id
          status
          email
          firstName
          lastName
          phone
        }
        account {
          id
          businessName
          displayName
          accountType
        }
      }
      nextToken
    }
  }
`;

// managerApp/customerList
export const searchCustomerReloadYardAccounts = /* GraphQL */ `
  query SearchCustomerReloadYardAccounts(
    $filter: SearchableCustomerReloadYardAccountFilterInput
    $sort: SearchableCustomerReloadYardAccountSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchCustomerReloadYardAccounts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        accountName
        customerId
        customer {
          id
          status
          email
          firstName
          lastName
          phone
        }
        account {
          id
          businessName
          displayName
          accountType
        }
      }
      nextToken
      total
    }
  }
`;

export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      status
      cognitoId
      email
      firstName
      lastName
      phone
      reloadYardAccounts {
        items {
          id
          owner
          active
          groups
          customerId
          email
          lastName
          reloadYardId
          accountId
          accountName
          account {
            id
            businessName
            displayName
            accountType
          }
          acl
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
